import { CustomFieldDefinition } from '../types/resources/CustomFieldDefinition';
import { CustomFieldValue } from '../types/resources/CustomFieldValue';

export type CustomFieldValuesFormType = Record<string, string | string[]>;
export type CustomFieldValuesType = Record<string, string>;
export type CustomFieldValuesForApiType = {
  label: string;
  value: string | string[];
};

export const groupCustomFieldValuesByLabel = (
  customFieldValues: CustomFieldValue[]
): CustomFieldValuesType => {
  return customFieldValues.reduce(
    (acc, field) => {
      const value = field.value.toString();
      const label = field.label;
      if (acc[label]) {
        acc[label] = `${acc[label]},${value}`;
      } else {
        acc[label] = value;
      }
      return acc;
    },
    {} as Record<string, string>
  );
};

export const groupCustomFieldValuesByLabelAsArray = (
  customFieldValues: CustomFieldValue[]
): CustomFieldValuesFormType => {
  return customFieldValues.reduce(
    (acc, field) => {
      const value = field.value.toString();
      const label = field.label;

      if (!acc[label]) {
        acc[label] = value;
        return acc;
      }

      acc[label] = Array.isArray(acc[label]) ? [...acc[label], value] : [acc[label], value];

      return acc;
    },
    {} as Record<string, string | string[]>
  );
};

export const formatCustomFieldValuesForApi = (
  customFieldValuesGroup: CustomFieldValuesFormType
): CustomFieldValuesForApiType[] => {
  return Object.entries(customFieldValuesGroup).map(([label, value]) => ({
    label,
    value,
  }));
};

export const getDisplayValue = (field: CustomFieldDefinition, value: string) => {
  switch (field.input_type) {
    case 'choice':
      return getChoiceValue(field, value);
    case 'multi_choice':
      return getMultiChoiceValue(field, value);
    default:
      if (field.value_type === 'bool') {
        return getBoolDisplayValue(value);
      }

      return value.toString();
  }
};

const getBoolDisplayValue = (value: string) => {
  if (value === 'true') return 'はい';
  if (value === 'false') return 'いいえ';
  return value;
};

const getMultiChoiceValue = (field: CustomFieldDefinition, value: string) => {
  const values = value.split(',');
  return values.map(v => getChoiceValue(field, v)).join(', ');
};

const getChoiceValue = (field: CustomFieldDefinition, value: string) => {
  return field.options?.[value] || value;
};
